import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { TableData } from './tabledata/tabledata.model';


@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {

  db_selected: string = "mysql"
  selectedType: string = "file";
  db_form = new FormGroup({
    db_type: new FormControl(''),
    hostname: new FormControl(''),
    port: new FormControl(''),
    name: new FormControl(''),
    username: new FormControl(''),
    password: new FormControl(''),
    filepath: new FormControl(''),
  })
  url: string = '';
  url2: string = '';
  result: any = null;
  error: string = '';
  allTables: TableData[] = [];

  headingKeys(obj: any): string[] {
    return Object.keys(obj);
  }
  selectedFile: File | null = null;

  onFileSelected(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files.length > 0) {
      this.selectedFile = fileInput.files[0];
    }
  }

  onSubmitUpload() {
    console.log("submit called");
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      console.log('Submitting file:', this.selectedFile.name);
      this.http.post('/api/test/upload', formData).subscribe(response => {
        const typedResponse = response as { content: string };
        console.log(typedResponse);

        this.result = typedResponse;
        this.error = '';

        console.log('File upload successful:', this.result);
      });
    }
  }

  constructor(private http: HttpClient) {
    console.log('AppComponent loaded');
    this.selectedType = "file"
  }

  scrape() {
    console.log('Scraping URL:', this.url);

    this.http.post<any>('/api/test/scrape', { source: this.url }).subscribe({
      next: (data) => {
        this.result = data;
        this.error = '';
      },
      error: (err) => {
        console.error('Scraping error:', err);

        this.error = err.error?.error || 'Something went wrong';
        this.result = null;
      },
    });
  }

  onSubmit() {
    var db_type = this.db_form.get('db_type')?.value
    var hostname = this.db_form.get('hostname')?.value
    var port = this.db_form.get('port')?.value
    var name = this.db_form.get('name')?.value
    var username = this.db_form.get('username')?.value
    var password = this.db_form.get('password')?.value
    var filepath = this.db_form.get('filepath')?.value
    console.log(this.db_form.get('db_type')?.value)
    console.log(this.db_form.get('hostname')?.value)
    console.log(this.db_form.get('port')?.value)
    console.log(this.db_form.get('name')?.value)
    console.log(this.db_form.get('username')?.value)
    console.log(this.db_form.get('password')?.value)

    this.http.post<any>('/api/test/local_db_scrape',
      { db_type: db_type, hostname: hostname, port: port, name: name, username: username, password: password, filepath: filepath }).subscribe({
        next: (resp) => {
          console.log("Full HTTP Response:", resp.id);
          this.result = resp;
          this.getTables(Number(resp.id))
        },
        error: (err) => {
          console.error('Scraping error:', err);
          this.error = err.error?.error || 'Something went wrong';
          this.result = null;
        }
      });
  }

  onToggleChange(event: any) {
    console.log(event.value);
    this.selectedType = event.value
  }

  selectdb(event: any) {
    console.log(event.value);
  }

  getTables(databaseId: number) {
    this.http.get<any[]>('/api/test/tables', { params: { databaseId } }).subscribe({
      next: (tablesResp) => {
        this.allTables = [];
        for (const table of tablesResp) {
          const tableData: TableData = {
            tableId: table.id,
            tableName: table.name,
            columns: [],
            displayedColumns: [],
            dataSource: []
          };

          this.http.get<any[]>('/api/test/columns', { params: { tableId: table.id } }).subscribe({
            next: (columnsResp) => {
              tableData.columns = columnsResp.map(c => c.name);
              tableData.displayedColumns = [...tableData.columns];
            },
            complete: () => {
              this.http.get<any[]>('/api/test/rows', { params: { tableId: table.id } }).subscribe({
                next: (rowsResp) => {
                  tableData.dataSource = rowsResp.map(row => row.data);
                },
                complete: () => {
                  this.allTables.push(tableData);
                }
              });
            }
          });
        }
      }
    });
  }
}
